import { render, staticRenderFns } from "./EditarInforme.vue?vue&type=template&id=0bb76294"
import script from "./EditarInforme.vue?vue&type=script&lang=js"
export * from "./EditarInforme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports